export default __webpack_public_path__ + "static/media/found-box-icon.e892aeaf.svg";